<script>
import PaxTotalsBase from './paxTotalsBase.vue'

export default {
  page() {
    return {
      title: 'Nationality Report',
      meta: [
        {
          name: 'description',
          content: ``,
        },
      ],
    }
  },
  components: { PaxTotalsBase },
  data() {
    return {
      routeKey: 'allnat',
      key1: 'TotalCkd',
      key2: 'Nationality',
      key2plural: 'Nationalities',
      sortKey: 'value',
      excludeKeys: ['Destination', 'TourOperator']
    }
  },
}
</script>

<template>
  <PaxTotalsBase
    :route-key="routeKey"
    :key1="key1"
    :key2="key2"
    :key2plural="key2plural"
    :sort-key="sortKey"
  />
</template>
